export default {
    props: {
        draggableEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'draggable.enabled'
        },
        draggableHint: {
            type: [Function, String],
            default: undefined,
            kComposite: 'draggable.hint'
        },
        draggablePlaceholder: {
            type: [Function, String],
            default: undefined,
            kComposite: 'draggable.placeholder'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listbox-vue-wrapper/src/KendoListBox/Draggable.js